module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "logo-icon",
    class: {
      animating: _vm.isLoading
    },
    style: (_vm.iconStyle),
    attrs: {
      "width": "92px",
      "height": "71px",
      "viewBox": "0 0 92 71",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#123C4C' : '#123C4C',
      "points": "45.9 53 56.1 56 61.2 61.8 45.9 70.6 30.6 61.8 36.6 56.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#12466D' : '#12466D',
      "points": "30.6 44.1 45.9 53 38.2 57.4 30.6 61.8 15.3 53 22.6 46.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#12466D' : '#12466D',
      "points": "61.2 44.1 69.1 46.5 76.5 53 61.2 61.8 53.5 57.4 45.9 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#165D91' : '#165D91',
      "points": "61.2 44.1 61.2 26.5 69.3 29.3 76.5 35.3 76.5 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#165D91' : '#165D91',
      "points": "30.6 44.1 30.6 26.5 22.7 29 15.3 35.3 15.3 53"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#000000",
      "fill-rule": "nonzero",
      "fill-opacity": "0.1",
      "points": "30.6 26.5 22.7 29 15.3 35.3 30.6 29.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": "#000000",
      "fill-rule": "nonzero",
      "fill-opacity": "0.1",
      "points": "61.2 26.5 69.1 29 76.5 35.3 61.2 29.3"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#66B6F2' : '#1A6BA8',
      "points": "76.5 17.7 91.7 26.5 76.5 35.3 61.2 26.5 67.8 21.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#66B6F2' : '#1A6BA8',
      "points": "15.3 17.7 0 26.5 15.3 35.3 30.6 26.5 25.2 20.2"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#AFD8F2' : '#1E88D8',
      "points": "61.2 8.8 76.5 17.7 61.2 26.5 45.9 17.7 52.4 12.1"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#AFD8F2' : '#1E88D8',
      "points": "30.6 8.8 15.3 17.7 30.6 26.5 45.9 17.7 40.2 12.4"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "fill": _vm.isLight ? '#FFFFFF' : '#1B90F5',
      "points": "45.9 0 45.9 0 45.9 0 61.2 8.8 45.9 17.7 30.6 8.8"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9272a4e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/LogoIcon.vue
// module id = 545
// module chunks = 2